import { registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Lara from '@primeuix/themes/lara';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AuthService } from 'src/services/auth.service';
import { SpinnerService } from 'src/services/spinner.service';
import { UserLoginService } from 'src/services/usuario-login.service';
import { UserService } from 'src/services/user.service';
import { ProjectClientService } from 'src/services/project-client.service';

registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
    provideHttpClient(),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Lara, options: {
          darkModeSelector: '.app-dark', semantic: {
            primary: {
              500: '#f59e0b' // Cor Amber/Laranja fixa em HEX
            }
          }
        }
      }
    }),
    MessageService,
    ConfirmationService,
    MessageService,
    UserLoginService,
    UserLoginService,
    AuthService,
    ProjectClientService,
    SpinnerService,
    UserService
  ]
};
